import axios from "axios";
import {
  INVENTORY_ALL_CABANG_GET_FAIL,
  INVENTORY_ALL_CABANG_GET_REQUEST,
  INVENTORY_ALL_CABANG_GET_RESET,
  INVENTORY_ALL_CABANG_GET_SUCCESS,
} from "../constants/InventoryAllCabangConstants";
import {
  API_INVENTORY_ALL_CABANG_GET,
  API_INVENTORY_ALL_CABANG_GET_DOWNLOAD,
} from "../init/api_url";
import { Logout } from "../../loginModul/actions/loginAction";
import { ActGeneralButtonDownloadSuccess } from "../../../general/components/button/ButtonDownloadsrc/action";

export const DownloadGetInventoryAllCabang =
  ({ minStok }) =>
  async (dispatch, getState) => {
    let fileName = "Inventory.xlsx";
    const {
      userLogin: { token },
    } = getState();

    const data = await axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: API_INVENTORY_ALL_CABANG_GET_DOWNLOAD,
      method: "GET",
      responseType: "blob", // important
      params: {
        minStok: minStok,
      },
    });
    console.log("Download Data", data["Content-Disposition"], data);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    dispatch(ActGeneralButtonDownloadSuccess());
  };

export const GetInventoryAllCabang =
  ({ minStok }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: INVENTORY_ALL_CABANG_GET_REQUEST,
      });
      const {
        userLogin: { token },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          minStok: minStok,
        },
      };
      const { data: data } = await axios.get(
        API_INVENTORY_ALL_CABANG_GET,
        config
      );
      console.log("testing Action get inventory all cabang", data);
      dispatch({
        type: INVENTORY_ALL_CABANG_GET_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch(Logout());
      }
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: INVENTORY_ALL_CABANG_GET_FAIL,
        payload: message,
      });
    }
  };

export const RGetInventoryAllCabang = () => async (dispatch, getState) => {
  dispatch({
    type: INVENTORY_ALL_CABANG_GET_RESET,
  });
};
